var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-button whatsapp"},[_c('a',{attrs:{"href":_vm.phone,"target":"_blank"}},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/dtc-2012.appspot.com/o/assets%2Fwhatsapp.svg?alt=media&token=cb28f069-d9cc-4548-815f-80f8997cf8a7","alt":"Whatsapp icon","height":"48"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }